import React from 'react';
import { useTranslation } from 'react-i18next';

function ListingCard() {
  const { t } = useTranslation('common');

  return (
    <div className="listing-card card">
      <div className="card-header">
        <div>
          <ul className="card-header-icon">
            <li>
              <div className="cus-chk-block">
                <input name="check_0" id="check_0" type="checkbox" />
                <label htmlFor="check_0" className="cus-chklabel" />
              </div>
            </li>
            <li>
              <a href={false} title={t('LISTING_CARD.EDIT')}>
                <i className="icon-edit" />
              </a>
            </li>
            <li>
              <a href={false} title={t('LISTING_CARD.DELETE')}>
                <i className="icon-delete" />
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="card-body">
        <h4 className="title link-title">
          {t('LISTING_CARD.TEST_LIB')}
          <a href={false}>
            {' '}
            <i className="icon-detail_page pl-1" />
          </a>
        </h4>
        <ul className="card-ul">
          <li>
            <strong>{t('LISTING_CARD.PRODUCT_ASSOCIATION')}: </strong>
            {t('LISTING_CARD.ACCESSORIES_ARTWORK')}
          </li>
          <li>
            <strong>{t('LISTING_CARD.ADDITIONAL_INFO')}: </strong>
            {t('LISTING_CARD.TEST')}
          </li>
          <li>
            <strong>{t('LISTING_CARD.CREATED_BY_DATE_TIME')}: </strong>
            {t('LISTING_CARD.MATANG_RAMDEVPUTRAM')} <span> 12:11 </span>
          </li>
          <li>
            <strong>{t('LISTING_CARD.MODIFIED_BY_DATE_TIME')}: </strong>
            {t('LISTING_CARD.MATANG_RAMDEVPUTRAM')} <span>12:11 </span>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default ListingCard;
